import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetAllInvestorsApi,
  GetInvestmentApi,
  GetInvestorByIdApi,
} from "../../ApiRequests";

export const fetchInvestments = createAsyncThunk(
  "fetch/Investments",
  async (id) => {
    try {
      let response;
      if (id) response = await GetInvestmentApi(id);
      return response?.data?.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const InvestmentsSlice = createSlice({
  name: "Investments",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchInvestments.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchInvestments.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchInvestments.rejected, (state, action) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default InvestmentsSlice.reducer;
